export default {"src":"/_next/static/media/arrow-left_black.8d427a03.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};